import { Grid, Skeleton } from '@mui/material'


const FullScreenMultiImageSkeleton = () => {
    return (
        <Grid className='container-height-without-drawer mt-10' container gap={"1rem"} padding={"20px"}>
            {[...Array(4)].map(() => (
                <Skeleton animation="wave" width={"20%"} height={80} sx={{ transform: 'unset' }} />
            ))}
        </Grid>
    )
}

export default FullScreenMultiImageSkeleton